import { render, staticRenderFns } from "./pricePage.vue?vue&type=template&id=e6205fba&scoped=true&"
import script from "./pricePage.vue?vue&type=script&lang=js&"
export * from "./pricePage.vue?vue&type=script&lang=js&"
import style0 from "./pricePage.vue?vue&type=style&index=0&id=e6205fba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6205fba",
  null
  
)

export default component.exports